import i18next from 'i18next';

const pricePanelConfig = () => ({
  title: i18next.t('pricePanel.title'), // Adicionado suporte para tradução
  path: '/products/price-panel',
  childrensub: [
    { title: i18next.t('pricePanel.stores.title'), path: '/products/price-panel/stores' },
    { title: i18next.t('pricePanel.categories.title'), path: '/products/price-panel/categories' },
    { title: i18next.t('pricePanel.products.title'), path: '/products/price-panel/products' },
    { title: i18next.t('pricePanel.prices.title'), path: '/products/price-panel/prices' },
  ],
});

export default pricePanelConfig;
